import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedFlowList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined)[];
}

interface IUseFlows {
  ordering?: string;
  action?: string;
  recipients?: string;
  notificationType?: string;
  limit?: string;
}

function useFlows({
  ordering,
  action,
  recipients,
  notificationType,
  limit = '20',
}: IUseFlows): UseInfiniteQueryResult<AxiosResponse<PaginatedFlowList>> {
  const fetchFlows = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedFlowList>> => {
    const params = pageParam;

    if (action) {
      params.action = action;
    }
    if (recipients) {
      params.recipients = recipients;
    }
    if (notificationType) {
      params.notification_type = notificationType;
    }

    if (ordering) {
      params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
    }

    return client.get(`flows/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['flows', action, recipients, notificationType, ordering], fetchFlows, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useFlows;
